import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAuthenticated, isSessionExpiring } = useAuth();

  // Mostrar loading mientras se verifica la sesión
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  // Si la sesión está expirando, no redirigir todavía
  if (isSessionExpiring) {
    return children;
  }

  // Una vez que terminó de cargar, verificar autenticación
  if (!isAuthenticated()) {
    console.log('Usuario no autenticado, redirigiendo al login');
    return <Navigate to="/login" replace />;
  }

  // Usuario autenticado, mostrar el contenido protegido
  return children;
};

export default ProtectedRoute;